import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, tap } from 'rxjs/operators';

// export interface NotificationModel {
//   type: string;
//   message: string;
//   timestamp: Date;
//   source: string;
//   destination: any;
// }

@Component({
  selector: 'app-sns-notifications',
  templateUrl: './sns-notifications.component.html',
  styleUrls: ['./sns-notifications.component.scss']
})
export class SnsNotificationsComponent implements OnInit {
  values: any[];

  groupedValues: any[];

  groupByNames = false;

  statusClass = 'success';

  showSubscriptions = false;

  filter: 'Bounce'|'Complaint'|'' = '';

  filteredValues = [];

  constructor(private http: HttpClient) { }

  ngOnInit() {
    this.getValues();
  }

  // ngDoCheck() {
  //   console.log(this.groupedValues);
  //   console.log(this.values);
  // }

  getValues() {
    this.http.get<any[]>('/api').subscribe((response/* : NotificationModel[] */) => {
      //console.log(response);
      this.values = response;

      this.groupedValues = [];

      this.values.forEach((item: any) => {
        const exists = this.groupedValues.findIndex(val => val.key === item.mail.destination);
        // console.log(exists, this.groupedValues[exists]);
        const newArray = [];
        newArray.push(item);
        if (exists > -1) {
          this.groupedValues[exists].notifications.push(item);
        } else {
          this.groupedValues.push({
            key: item.mail.destination,
            notifications: newArray
          });
        }
      });

      //console.log(this.groupedValues);

    }, error => {
      console.log(error);
    });
  }

  groupByName() {
    this.groupByNames = !this.groupByNames;
    //console.log("grouped by names " + this.groupByNames);
  }

  backToTop = (): any => document.getElementsByTagName('html')[0].scrollTop = 0;

}
